const SplashScreen = () => {
  return <div className='splashscreen'></div>
}

export default SplashScreen
